<template>
  <Modal
    ref="modal"
    title="Change State"
  >
    <BaseForm
      submit-title="Save"
      @submit="save"
      @cancel="cancel"
    >
      <BaseInput
        :value="projectStateName"
        title="Current Status"
        name="project_state"
        readonly
      />
      <BaseSelect
        v-show="next_states.length > 0"
        v-model="next_state"
        :options="next_states"
        title="New Status"
        name="next_state"
        track-by="id"
        label="name"
        required
      />
      <BaseInput
        v-if="next_states.length === 0"
        value="No states"
        title="New Status"
        name="next_state"
        readonly
      />
      <FieldError v-model="error" />
    </BaseForm>
  </Modal>
</template>

<script>
/**
 * Modal to change a Projects state.
 * Emits a 'state-change' even with project record when state is changed.
 */
import Modal from '@/components/Modal'
import FieldError from '@/components/FieldError'
import projectAPI from '@/api/project'

export default {
  components: {
    Modal,
    FieldError,
  },
  data () {
    return {
      error: '',
      project: {},
      next_state: null,
      next_states: [],
    }
  },
  computed: {
    projectStateName () {
      if (this.project.project_state) {
        return this.project.project_state.name
      }
      return ''
    },
  },
  methods: {
    reset () {
      this.error = ''
      this.project = {}
      this.next_state = null
      this.next_states = []
    },
    cancel () {
      this.$refs.modal.hide()
      this.reset()
    },
    edit (project, nextStates) {
      this.reset()
      this.project = project
      this.next_states = nextStates.sort((a, b) => a.name > b.name)
      if (this.next_states.length <= 0) {
        return
      }
      this.$refs.modal.show()
    },
    save () {
      projectAPI.updateState(this.project.id, this.next_state).then(resp => {
        /** project state changed */
        this.$emit('state-change', this.next_state)
        this.cancel()
      }).catch(error => {
        this.error = error.message
      })
    },
  },
}
</script>
